<template>
  <div
    class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header m-0"
  >
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-size-100 truncated_header2"
      >
        <div class="md-layout md-alignment-center">
          <div
            class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60 p-0"
          >
            <h1 class="title-h4-formatting">
              Sole Proprietorship Industry Financial Profile
            </h1>
            <ul>
              <li>
                <p class="sub-title-formatting">
                  <i class="md-icon md-icon-dark-blue">business_center</i
                  >Industry:
                </p>
                <p>{{ this.headerData.industry }}</p>
              </li>
              <li>
                <p class="sub-title-formatting">
                  <i class="md-icon md-icon-dark-blue">apartment</i>Sector:
                </p>
                <p>{{ this.headerData.sector }}</p>
              </li>
              <li>
                <p class="sub-title-formatting">
                  <i class="md-icon md-icon-dark-blue">place</i>Market Area:
                </p>
                <p>{{ this.headerData.area }}</p>
              </li>
              <!-- <li>
                      <h6>
                        <i class="md-icon">equalizer</i>Sales Class:
                      </h6>
                      <p>Sole Proprietorship</p>
                    </li> -->
            </ul>
          </div>
          <div
            class="md-layout-item md-medium-size-100 md-xsmall-size-50 md-size-40 button-box"
          >
            <md-button class="md-info access-button pdf_btn" @click="feedback">
              <md-icon>comment</md-icon>Product Feedback
            </md-button>
            <md-button
              v-if="data && data.years && !pdfLoading"
              class="md-info access-button pdf_btn"
              @click="downloadPDFData"
            >
              <md-icon class="ml-5">picture_as_pdf</md-icon>Download PDF
            </md-button>
            <md-button
              v-if="!data || !data.years"
              class="md-info access-button pdf_btn"
            >
              <template>
                <md-icon class="ml-5">picture_as_pdf</md-icon>Loading...
              </template>
            </md-button>
            <md-button v-if="pdfLoading" class="md-info access-button pdf_btn">
              <template>
                <md-icon class="ml-5">picture_as_pdf</md-icon>Downloading...
              </template>
            </md-button>
            <md-button
              class="md-info access-button csv_btn"
              @click.native="downloadCSVData"
              ><md-icon class="ml-5">receipt_long</md-icon>Download CSV
            </md-button>
          </div>
        </div>
      </div>
      <modal
        v-if="feedbackModal"
        @close="feedbackModal = false"
        class="feedback_modal"
      >
        <template slot="body">
          <button
            type="button"
            class="close_btn"
            @click="feedbackModal = false"
          >
            <md-icon>clear</md-icon>
          </button>
          <h3 class="modal-title">Have feedback on this product?</h3>
          <p>
            Enter the details below to send your feedback to our Product Team.
          </p>
          <form action class="form_grp">
            <div class="field_wpr">
              <label>Leave A Feedback Note</label>
              <textarea
                v-model="textFeedback"
                placeholder="Type a message"
              ></textarea>
              <md-button @click="sendFeedback" class="md-info md-round mt-4"
                >Send Feedback</md-button
              >
              <div class="md-layout-item">
                <md-checkbox v-model="checkBoxOption1"
                  >1 - Report An Error</md-checkbox
                >
                <md-checkbox v-model="checkBoxOption2" class="pl-3"
                  >2 - Suggest an Improvement</md-checkbox
                >
                <md-checkbox v-model="checkBoxOption3"
                  >3 - Request a Correction</md-checkbox
                >
                <md-checkbox v-model="checkBoxOption4"
                  >4 - Request an Update</md-checkbox
                >
              </div>
            </div>
          </form>
        </template>
      </modal>
    </div>
    <SPIFPPDF
      ref="spifPDF"
      :headerInfo="headerData"
      :information="{
        tableDataFirmsAnalyzed,
        colouredLineChart,
        naicsDrilldown,
      }"
    />
  </div>
</template>

<script>
import ratingMixin from "@/mixins/rating-mixin";
import formatData from "@/mixins/format-data";
import { mapActions, mapState } from "vuex";
import { Collapse } from "@/components";
import Avatar from "vue-avatar";
import SPIFPPDF from "./SPIFPPDF.vue";
import moment from "moment";

export default {
  components: {
    //Collapse,
    //Avatar
    SPIFPPDF,
  },
  mixins: [ratingMixin, formatData],
  props: ["headerData"],
  data() {
    return {
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          // lineSmooth: this.$Chartist.Interpolation.cardinal({
          //   tension: 10,
          // }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "300px",
        },
      },
      multiplesTableInfo: [
        {
          id: "Low",
          name: "Q1",
        },
        {
          id: "Med",
          name: "Median",
        },
        {
          id: "High",
          name: "Q3",
        },
      ],
      tableDataFirmsAnalyzed: [],
      loading: false,
      naicsDrilldown: {},
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      annualCashRatiosDolFilteredData: [],
      annualCashRatiosPercentFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      sales_class_csv: "",
      feedbackModal: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      spif: (state) => state.user.profile.spif,
      data: (state) => state.user.profile.data,
      profile: (state) => state.user.profile,
      pdfLoading: (state) => state.user.pdfLoading,
      PLtable: (state) =>
        state.user.profile.data.tables
          ? state.user.profile.data.tables["PL"]
          : state.user.profile.data.tables["PL"],
      BStable: (state) =>
        state.user.profile.data.tables
          ? state.user.profile.data.tables["BS"]
          : state.user.profile.data.tables["BS"],
      tables: (state) =>
        state.user.profile.data.tables
          ? state.user.profile.data.tables["ratios"]
          : null,
      tablesAll: (state) =>
        state.user.profile.data.tables ? state.user.profile.data.tables : null,
      tablesInfo: (state) =>
        state.user.profile.data.tables
          ? state.user.profile.data.tables["ratioInfo"]
          : state.user.profile.data.tables["ratioInfo"],
      sourcesUses: (state) =>
        state.user.profile["sourcesUses"]
          ? state.user.profile["sourcesUses"]
          : state.user.profile.data["sourcesUses"],
      sourceYears: (state) =>
        state.user.profile["data"] ? state.user.profile.data["years"] : null,
      release_display: (state) =>
        state.user.profile.data.data.data[0].release_display,
      bznaics_code: (state) => state.user.profile.data.data.data[0].bznaics,
      sector_name: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].sector
          : "",
      industry_title: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].industry
          : "",
      sales_class: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].sales_class
          : "",
      display_area: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].display_area
          : "",
      years: (state) => state.user.profile.data.years,
      multiplesA: (state) => {
        return state.user.profile.data["multiples_A"]
          ? state.user.profile.data["multiples_A"]
          : [];
      },
      multiplesB: (state) => {
        return state.user.profile.data["multiples_B"]
          ? state.user.profile.data["multiples_B"]
          : [];
      },
      multiplesC: (state) => {
        return state.user.profile.data["multiples_B"]
          ? state.user.profile.data["multiples_B"]
          : [];
      },
      multiplesAll: (state) => {
        return state.user.profile.data["multiples_all"]
          ? state.user.profile.data["multiples_all"]
          : [];
      },
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, "years");
    },
    filteredProfile() {
      return Object.values(this.profile.data.data.data).filter((item) => item);
    },
    getCsvData() {
      let csvData = [
        ["Sole Proprietorship Industry Financial Profile"],
        ['"Release Date"', this.release_display],
        [""],
        ["Segment", "Industry"],
        //[this.industry_title],
        ["[" + parseInt(this.bznaics_code) + "]" + " Sector", this.sector_name],
        ["Market", this.headerData.area],
        [""],
      ];
      csvData.push(["Firms Analyzed", this.filtered_years]);

      if (this.filtered_firms) {
        csvData.push(["", this.filtered_firms]);
        csvData.push([""]);
      }
      csvData.push(["Income and Expense - Profit and Loss($)"]);
      csvData.push(["", this.filtered_years]);
      this.filtered_PLDollar.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });

      csvData.push([""]);
      csvData.push(["Income and Expense - Profit and Loss(%)"]);
      csvData.push(["", this.filtered_years]);
      this.filtered_PLPercent.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      // csvData.push(['']);
      // csvData.push(['Balance Sheet($)']);
      // csvData.push(['Assets', this.filtered_years]);
      // this.filtered_BSDollar.forEach((e, i) => {
      //    if (typeof e === 'string' && e.includes(',')) {
      //     e = e.replace(/,/g, '');
      //   }
      //   csvData.push(e);
      // });
      // csvData.push(['']);
      // csvData.push(['Balance Sheet(%)']);
      // csvData.push(['Assets', this.filtered_years]);
      // this.filtered_BSPercent.forEach((e, i) => {
      //   if (typeof e == 'string' && e.includes(',')) {
      //     e = e.replace(/,/g, '');
      //   }
      //   csvData.push(e);
      // });
      csvData.push([""]);
      csvData.push(["Financial Ratios: Cash Flow-Solvency"]);
      csvData.push(["", this.filtered_years]);
      this.cashFlowFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Financial Ratios: Profitability"]);
      csvData.push(["", this.filtered_years]);
      this.profitabilityFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Financial Ratios: Efficiency"]);
      csvData.push(["", this.filtered_years]);
      this.efficiencyFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Annual Cash Ratios ($)"]);
      csvData.push(["", this.filtered_years]);
      this.annualCashRatiosDolFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Annual Cash Ratios (%)"]);
      csvData.push(["", this.sourceYears]);
      this.annualCashRatiosPercentFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });

      // ------------------- Valuation -------------------------
      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Valuation Multiples"]);
      csvData.push(["Sales Group: < $2.5m:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesA[`Sales${item.id}`],
          this.multiplesA[`Earnings${item.id}`],
        ]);
      });

      csvData.push([""]);

      csvData.push(["Sales Group: $2.5m - $24.9m:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesB[`Sales${item.id}`],
          this.multiplesB[`Earnings${item.id}`],
        ]);
      });

      csvData.push([""]);

      csvData.push(["Sales Group: > $25m:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesC[`Sales${item.id}`],
          this.multiplesC[`Earnings${item.id}`],
        ]);
      });

      csvData.push([""]);

      csvData.push(["Sales Group: All:"]);
      csvData.push(["", "Sales Multiples", "Earnings Multiples"]);

      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([
          item.name,
          this.multiplesAll[`Sales${item.id}`],
          this.multiplesAll[`Earnings${item.id}`],
        ]);
      });

      return csvData;
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]["cashflow"];
    },
  },
  mounted() {
    this.$store.commit("user/SET_PDF_LOADING", false);
    // this.parseCSVData();
    this.initData();
  },
  methods: {
    ...mapActions({
      registerProductExport: "tracking/registerProductExport",
    }),

    initData() {
      if (!this.data || !this.data.years) {
        return;
      }
      this.data.years.forEach((e, i) => {
        this.filtered_years.push(e);
      });

      this.naicsDrilldown = this.profile.data.naicsDrilldown;
      this.colouredLineChart.data = {
        labels: this.profile.data.years,
        series: [this.filteredProfile.map((item) => item.firms)],
      };

      let firmData = Object.values(this.profile.data.data.data)
        .filter((item) => item)
        .map((item) => ({ ...item, firms: item.firms }));
      firmData.forEach((element) => {
        if (element.firms) this.filtered_firms.push(parseFloat(element.firms));
      });

      let PLdollar = this.formatTable(this.PLtable, "industry", "dollar");
      let PLpercent = this.formatTable(this.PLtable, "industry", "percent");

      PLdollar.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PLDollar.push(v);
      });
      PLpercent.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercent.push(v);
      });

      let BSdollar = this.formatTable(this.BStable, "industry", "dollar");
      let BSpercent = this.formatTable(this.BStable, "industry", "percent");

      BSdollar.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });

        v.unshift(element.name);
        this.filtered_BSDollar.push(v);
      });
      BSpercent.forEach((element) => {
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === "string" && item.includes(",")) {
            item = parseFloat(item.replace(/,/g, ""));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercent.push(v);
      });

      // ----------------------- Cash Flow --------------------------------

      let CFtable = {
        "Net Cash turnover (X)": this.tables.cashflow["Net Cash turnover (X)"],
        "Net Cash/ Revenue %": this.tables.cashflow["Net Cash/ Revenue %"],
      };

      let CFdollarIndustry = this.formatTable(CFtable, "industry");

      CFdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.cashFlowFilteredData.push(v);
      });

      // -------------------------- Efficiency ----------------------

      let Etable = {
        "Cost of Sales: Inventory (x)": this.tables["efficiency"][
          "Cost of Sales: Inventory (x)"
        ],
        "Days Inventory": this.tables["efficiency"]["Days Inventory"],
        "EBITDA: Interest": this.tables["efficiency"]["EBITDA: Interest"],
        "Inventory Turnover": this.tables["efficiency"]["Inventory Turnover"],
        "Total Labor: Revenue": this.tables["efficiency"][
          "Total Labor: Revenue"
        ],
      };

      let EdollarIndustry = this.formatTable(Etable, "industry");

      EdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.efficiencyFilteredData.push(v);
      });

      // -------------------------- Profitability ----------------------

      let Ptable = {
        "EBITDA: Revenue": this.tables["profitability"]["EBITDA: Revenue"],
        "Gross Profit: Revenue": this.tables["profitability"][
          "Gross Profit: Revenue"
        ],
        "Owner Earnings per Employee": this.tables["profitability"][
          "Owner Earnings per Employee"
        ],
        "Profit per Employee": this.tables["profitability"][
          "Profit per Employee"
        ],
        "Return on Revenue (%)": this.tables["profitability"][
          "Return on Revenue (%)"
        ],
      };

      let PdollarIndustry = this.formatTable(Ptable, "industry");

      PdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.profitabilityFilteredData.push(v);
      });

      // ------------------------- Annual Cash Ratios Dol ------------------------------

      let ACDtable = {
        "All Direct Expenses": this.tablesAll["annual_cash_ratios_dollar"][
          "All Direct Expenses"
        ],
        "Cost of Sales": this.tablesAll["annual_cash_ratios_dollar"][
          "Cost of Sales"
        ],
        "Gross Profit": this.tablesAll["annual_cash_ratios_dollar"][
          "Gross Profit"
        ],
        "Net Cash": this.tablesAll["annual_cash_ratios_dollar"]["Net Cash"],
        "Net Cash & Labor": this.tablesAll["annual_cash_ratios_dollar"][
          "Net Cash & Labor"
        ],
        Revenue: this.tablesAll["annual_cash_ratios_dollar"]["Revenue"],
      };

      let ACdollarIndustry = this.formatTable(ACDtable, "industry", "dollar");

      ACdollarIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.annualCashRatiosDolFilteredData.push(v);
      });

      // ------------------------- Annual Cash Ratios Percent ------------------------------

      let ACPtable = {
        "Net Cash": this.tablesAll["annual_cash_ratios_percent"]["Net Cash"],
        "Net Cash/ All Direct Expenses": this.tablesAll[
          "annual_cash_ratios_percent"
        ]["Net Cash/ All Direct Expenses"],
        "Net Cash/ Cost of Sales": this.tablesAll["annual_cash_ratios_percent"][
          "Net Cash/ Cost of Sales"
        ],
        "Net Cash/ Gross Profit": this.tablesAll["annual_cash_ratios_percent"][
          "Net Cash/ Gross Profit"
        ],
        "Net Cash/ Net Cash & Labor": this.tablesAll[
          "annual_cash_ratios_percent"
        ]["Net Cash/ Net Cash & Labor"],
        "Net Cash/ Revenue": this.tablesAll["annual_cash_ratios_percent"][
          "Net Cash/ Revenue"
        ],
      };

      let ACpercentIndustry = this.formatTable(ACPtable, "industry", "percent");

      ACpercentIndustry.forEach((element) => {
        if (element.name.includes(",")) {
          element.name = element.name.replace(/,/g, "");
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === "string" && e.includes(",")) {
            e = parseFloat(e.replace(/,/g, ""));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.annualCashRatiosPercentFilteredData.push(v);
      });

      Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
        this.$set(this, table, this.formatSourcesData(table, data))
      );

      this.changein.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.changeinFilteredData.push(k);
      });
      this.worksheet.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.worksheetFilteredData.push(k);
      });
    },

    //  init() {
    //   this.tableDataFirmsAnalyzed = Object.values(this.profile.data.data.data)
    //     .filter((item) => item)
    //     .map((item) => ({ ...item, firms: this.numberWithCommas(item.firms) }));
    //   this.tableDataFirmsAnalyzed = _.orderBy(
    //     this.tableDataFirmsAnalyzed,
    //     ['year'],
    //     ['asc']
    //   );

    //   this.naicsDrilldown= this.profile.data.naicsDrilldown;
    //   this.colouredLineChart.data = {
    //     labels: this.profile.data.years,
    //     series: [this.filteredProfile.map((item) => item.firms)],
    //   };
    // },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return x;
      }
    },
    downloadCSVData() {
      let csv = "";
      this.getCsvData.forEach((row) => {
        csv += row.join(",");
        csv += "\n";
      });
      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Sole Proprietorship Profile.csv";
      anchor.click();
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: "CSV",
      });
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },

    sendFeedback() {
      if (this.category) {
        let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
        );
        axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "/user/feedback/submit",
            {},
            {
              params: {
                session_id: currentSession,
                feedback: this.textFeedback,
                url: `${window.location.href}`,
                category: this.category,
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }

            if (res.data.success)
              this.$store.dispatch("alerts/success", "Data saved.");
            else
              this.$store.dispatch(
                "alerts/error",
                "An error occured. please try again"
              );

            this.feedbackModal = false;
            this.textFeedback = null;
            this.category = null;

            this.checkBoxOption1 = false;
            this.checkBoxOption2 = false;
            this.checkBoxOption3 = false;
            this.checkBoxOption4 = false;
          });
      } else {
        this.$store.commit("SET_ERROR_BIT", true);
        this.$store.commit(
          "SET_ERROR_INFO",
          "<br>" +
            "Server responded with error = True <br> errorCode: " +
            "category_not_set" +
            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
        );
      }
    },
    feedback() {
      this.feedbackModal = true;
    },
    downloadPDFData() {
      this.$refs.spifPDF.generateReport();
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: "PDF",
      });
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          if (!this.$store.getters["user/pdfMustBeDownloaded"])
            window.open(pdf.output("bloburl"), "_blank");
        });
    },
  },

  watch: {
    profile(newval, oldval) {
      this.initData();
    },
  },
};
</script>
<style lang="scss"></style>
